import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white/70 print:hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 text-sm">
        <div className="flex-1 text-slate-500">
          © {new Date().getFullYear()} Blurblive.nz · Waikato, Aotearoa NZ · Kiwi-owned
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-slate-600">
          <Link to="/" className="hover:text-emerald-800" data-testid="footer-home">Home</Link>
          <Link to="/stores" className="hover:text-emerald-800" data-testid="footer-stores">Stores</Link>
          <Link to="/register" className="hover:text-emerald-800" data-testid="footer-register">List your store</Link>
          <Link to="/terms" className="hover:text-emerald-800" data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-emerald-800" data-testid="footer-privacy">Privacy</Link>
          <a href="mailto:franciscusvanhelmond@gmail.com" className="hover:text-emerald-800" data-testid="footer-contact">Contact</a>
        </nav>
      </div>
      <div className="border-t border-slate-100 py-3 text-center text-[11px] text-slate-400 px-4">
        Blurblive Markdowns is a listing platform. All transactions happen in-store — we never take payment for goods, only for listings.
      </div>
    </footer>
  );
}
